import React, { useEffect, useState } from 'react';
import { Button, Input, InputGroup, InputGroupText, Modal, ModalBody, ModalHeader } from 'reactstrap';
import style from './ApplyPage.style';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import ApplicationForm from './ApplicationForm/ApplicationForm';
import { postDataAgnostic } from 'Services/dataApi';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { formatBearerToken } from 'Common.functions';
import RezRateImg from '../../../../../../assets/images/header/rezRate.gif';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { RouterPrompt } from 'Body/RezRATE/Common/RouterPrompt/RouterPrompt';

let myApplications = [];

const ApplyPage = (props) => {
  const {
    applicantDetails,
    isFetchingApplications,
    applications,
    departmentData,
    getDepartmentDetails,
    setShowMode,
  } = props;
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isValidatingCode, setIsValidatingCode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [hasValidCode, setHasValidCode] = useState(null);
  const [codeType, setCodeType] = useState(null); // 'department' or 'opening'

  const [applicationDetails, setApplicationDetails] = useState(null);
  const [selectedOpening, setSelectedOpening] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const query = new URLSearchParams(useLocation().search);

  const { isAuthenticated, login, getToken } = useKindeAuth();

  const history = useHistory();

  const { location } = history;
  const { pathname } = location;
  const codeFromURL = query.get('applicationCode');

  // Alert functionality replaced with toast

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      if (windowWidth < windowHeight && windowWidth < 1100) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    myApplications = applications;
  }, [applications]);

  useEffect(() => {
    if (isAuthenticated) {
      if (codeFromURL && !isFetchingApplications) {
        setCode((prevData) => {
          verifyCode(codeFromURL);
          return codeFromURL;
        });
        // setHasValidCode(true);
      } else {
        setHasValidCode(false);
        setCode('');
      }
    }
  }, [codeFromURL, isAuthenticated, isFetchingApplications]);

  const verifyCode = async (forcedCode, cb) => {
    setIsValidatingCode(true);
    const token = await getToken();
    const codeToUse = forcedCode || code;
    if (codeToUse === 'null') {
      setShowMode('applications');
      history.push('/applicant/profile/applications');
      return;
    } //  For testing, creating app code for Matt's dept.
    postDataAgnostic('applicant/code/verify', null, { code: codeToUse }, formatBearerToken(token))
      .then((result) => {
        if (result.data && result.data.message && result.data.message === 'Invalid Code') {
          toast.error('Invalid Code');
        } else {
          setIsValidatingCode(false);

          setHasValidCode(true);

          if (result.data) {
            const existingApplication =
              result.data.Status == 'APPLICANT_HAS_EXISTING_APPLICATION' && result.data.ApplicationRecord
                ? result.data.ApplicationRecord
                : null;

            if (existingApplication) {
              if (cb) {
                cb(existingApplication);
              } else {
                Swal.fire({
                  title: 'Active application found',
                  text: `You have an active application for the department "${result.data.Department.DepartmentName}". Would you like to view it?`,
                  icon: 'info',
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                }).then((result) => {
                  if (result.isConfirmed) {
                    history.push(
                      `/applicant/profile/applications?selectedApplication=${existingApplication.fk_Department}`,
                    );
                  } else {
                    setCode('');
                  }
                });
              }
            } else {
              setApplicationDetails(result.data);
            }
          }
          getDepartmentDetails(codeToUse);

          // history.push(`/applicant/applicant_profile/new_application?applicationCode=${code}`);
        }
      })
      .catch((err) => {
        setIsValidatingCode(false);
        toast.error('Invalid Code');
        console.log('err: ', err);
      });
  };

  const renderCodeField = () => {
    return (
      <div
        style={{
          ...style.simpleRow,
          width: '100%',
          marginTop: isMobile && hasValidCode && applicationDetails ? 10 : '10vh',
        }}
      >
        {isMobile && hasValidCode && applicationDetails ? (
          renderApplicationForm()
        ) : (
          <div style={{ ...style.simpleColumn, width: '100%', maxWidth: 550 }}>
            <div style={{ ...style.simpleRow, width: '100%', marginBottom: 10, fontWeight: 'bold' }}>
              Enter Application Code
            </div>

            <div style={{ ...style.simpleRow, width: '100%', marginBottom: 0 }}>
              <InputGroup>
                <Input
                  type="text"
                  value={code}
                  placeholder="Enter Code"
                  disabled={isLoading || isValidatingCode || isFetchingApplications}
                  onChange={(e) => {
                    setCode(e.target.value);
                  }}
                />
                <Button
                  color="success"
                  disabled={isLoading || !code || isValidatingCode}
                  onClick={() => {
                    setIsValidatingCode(true);
                    setTimeout(() => {
                      verifyCode();
                    }, 2000);
                  }}
                >
                  Apply
                </Button>
              </InputGroup>
            </div>

            <div style={{ ...style.simpleRow, width: '100%', marginBottom: 10, fontSize: 10 }}>
              {isValidatingCode ? 'Validating code...' : isLoading ? 'Loading...' : ''}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderApplicationForm = () => {
    return (
      <ApplicationForm
        // applicationDetails={{ ...applicationDetails, Department: departmentData }}
        departmentData={{ ...applicationDetails, ...departmentData }}
        selectedOpening={selectedOpening}
        applicantDetails={applicantDetails}
        setExternalHasUnsavedChanges={setHasUnsavedChanges}
        isReadOnly={false}
        onApply={() => {
          setApplicationDetails(null);
          setHasValidCode(false);
          setCode('');
          history.push('/applicant/profile/new_application');
        }}
        onSave={() => {
          verifyCode(code, (existingApplication) => {
            if (existingApplication && existingApplication.fk_Department) {
              history.push(`/applicant/profile/applications?selectedApplication=${existingApplication.fk_Department}`);
            }
          });
        }}
      />
    );
  };

  const renderNewApplicationModal = () => {
    const { DepartmentName, DepartmentLogo } = departmentData || {};

    return (
      <Modal
        isOpen={hasValidCode && applicationDetails}
        style={{
          ...style.simpleRow,
          // height: '90vh',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '90vw',
        }}
      >
        <ModalHeader
          toggle={() => {
            if (hasUnsavedChanges) {
              Swal.fire({
                title: 'Discard Unsaved Changes?',
                text: 'Are you sure you want to discard changes?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Discard',
                cancelButtonText: 'No',
              }).then((result) => {
                if (result.isConfirmed) {
                  setHasUnsavedChanges(false);
                  setApplicationDetails(null);
                  setHasValidCode(false);
                  setCode('');
                  history.push('/applicant/profile/new_application');
                }
              });
            } else {
              setApplicationDetails(null);
              setHasValidCode(false);
              setCode('');
              history.push('/applicant/profile/new_application');
            }
          }}
        >
          {' '}
          Application for {DepartmentName ? DepartmentName : 'Unnamed Program'}
        </ModalHeader>
        <ModalBody>{renderApplicationForm()}</ModalBody>
      </Modal>
    );
  };

  const renderOpeningSelection = () => {
    const { Department, ApplicationOpenings } = applicationDetails;
    const { DepartmentLogo, DepartmentName } = Department;
    const hasOpenings = ApplicationOpenings && ApplicationOpenings.length > 0;

    return (
      <div style={{ ...style.simpleRow, width: '80%', minWidth: 700 }}>
        <div style={{ ...style.simpleColumn, width: 'calc(50px + (100% - 320px))', minWidth: 700 }}>
          <div style={{ ...style.simpleRow, width: '100%', marginBottom: 20 }}>
            <div style={{ ...style.simpleColumn, width: 80 }}>
              <img src={DepartmentLogo || RezRateImg} alt="Department Logo" style={{ width: 70, height: 70 }} />
            </div>
            <div style={{ ...style.simpleColumn, width: 'calc(100% - 80px)' }}>
              <div style={{ ...style.simpleRow, width: '100%', justifyContent: 'spaced-between' }}>
                <div style={{ ...style.simpleColumn, width: 'calc(100% - 80px', alignItems: 'flex-start' }}>
                  <b>{DepartmentName}</b>
                </div>
                <div
                  style={{
                    ...style.simpleColumn,
                    width: 'calc(100% - 80px',
                    fontSize: 20,
                    color: hasOpenings ? 'green' : 'red',
                  }}
                >
                  <b>{hasOpenings ? 'Openings Available' : 'No Openings'}</b>
                </div>
              </div>
              {/* <div style={{ ...style.simpleRow, width: '100%', justifyContent: 'left' }}>Openings Available</div> */}
            </div>
          </div>
          <div
            style={{
              ...style.simpleRow,
              width: '100%',
              height: 'calc(100vh - 320px)',
              overflowY: 'auto',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ ...style.simpleColumn }}>
              {applicationDetails.ApplicationOpenings.map((opening) => {
                return (
                  <div
                    style={{
                      ...style.simpleRow,
                      width: '100%',
                      border: '1px solid gray',
                      padding: 10,
                      marginBottom: 2,
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setSelectedOpening(opening);
                    }}
                  >
                    <div style={{ ...style.simpleColumn, width: '100%' }}>{opening.Title}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    // if (hasValidCode && applicationDetails) {
    //   return renderApplicationForm();
    //   if (selectedOpening) {
    //     return renderApplicationForm();
    //   } else if (applicationDetails) {
    //     return renderOpeningSelection();
    //   }
    // } else {
    return renderCodeField();

    // }
  };

  return (
    <div
      style={{
        ...style.simpleRow,
        width: '100%',
        padding: '10px 10px',
        height: 'calc(100vh - 180px)',
        alignItems: 'flex-start',
      }}
    >
      <div style={style.simpleColumn}>
        {isMobile && hasValidCode && applicationDetails ? (
          <div
            style={{
              ...style.simpleRow,
              justifyContent: 'flex-start',
              width: '100%',
              paddingLeft: 10,
              marginBottom: 5,
            }}
          >
            <Button
              size="sm"
              color="primary"
              onClick={() => {
                if (hasUnsavedChanges) {
                  Swal.fire({
                    title: 'Discard Unsaved Changes?',
                    text: 'Are you sure you want to discard changes?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Discard',
                    cancelButtonText: 'No',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setApplicationDetails(null);
                      setHasValidCode(false);
                      setCode('');
                      history.push('/applicant/profile/new_application');
                    }
                  });
                } else {
                  setApplicationDetails(null);
                  setHasValidCode(false);
                  setCode('');
                  history.push('/applicant/profile/new_application');
                }
              }}
            >
              <div style={{ ...style.simpleRow, justifyContent: 'space-between' }}>
                <FontAwesomeIcon icon={faChevronCircleLeft} style={{ marginRight: 10 }} />
                Back
              </div>
            </Button>
          </div>
        ) : null}
        {renderContent()}
      </div>
      <RouterPrompt
        hasChanges={hasUnsavedChanges}
        okLabel={'Discard Changes'}
        onOk={() => {
          setHasUnsavedChanges(false);

          return true;
        }}
      />
      {isMobile ? null : renderNewApplicationModal()}
    </div>
  );
};

export default ApplyPage;
